<template>
  <c-tab
    type="horizon"
    :dense="true"
    :inlineLabel="true"
    :tabItems.sync="tabItems"
    :height="tabHeight"
    v-model="tab"
  >
    <template v-slot:default="tab">
      <component
        :is="tab.component"
        :param="popupParam"
        @closePopup="closePopup"
      />
    </template>
  </c-tab>
</template>

<script>
export default {
  name: 'pre-startup-review-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopPrestartupCheckId: '',
        psrCheckStatusCd: '',
        isSearch: false,
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'base',
      tabItems: [
        { name: 'base', icon: 'foundation', label: '가동전점검 계획/결과 정보', component: () => import(`${'./preStartupReviewInfo.vue'}`) },
        { name: 'traningScenario', icon: 'account_tree', label: 'Punch list', component: () => import(`${'./preStartupImpr.vue'}`) },
      ],
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 45) + 'px';
    },
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
    closePopup() {
      this.$emit('closePopup')
    }
  }
};
</script>
